var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmissions = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 67,
    viewBox: "0 0 87 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50293 2.67212L26.8609 31.3284L53.7262 39.388L74.3229 59.0893",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4434 59.5371H74.7715V45.209",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5101 66.6265L22.0547 52.0308",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8027 49.5092L38.8301 39.1473",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6853 35.2107L53.4384 20.7534",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6615 16.8516L69.3291 6.01961",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.262,
    cy: 37.1739,
    r: 2.63429,
    transform: "rotate(-14.9402 41.262 37.1739)",
    fill: "white",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.8051,
    cy: 51.3673,
    r: 2.63429,
    transform: "rotate(-14.9402 22.8051 51.3673)",
    fill: "white",
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.069,
    cy: 18.0806,
    r: 2.63429,
    transform: "rotate(-34.4828 55.069 18.0806)",
    fill: "white",
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.6915,
    cy: 3.96454,
    r: 2.63429,
    transform: "rotate(-16.885 71.6915 3.96454)",
    fill: "white",
    stroke: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmissions);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODciIGhlaWdodD0iNjciIHZpZXdCb3g9IjAgMCA4NyA2NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNTAyOTMgMi42NzIxMkwyNi44NjA5IDMxLjMyODRMNTMuNzI2MiAzOS4zODhMNzQuMzIyOSA1OS4wODkzIiBzdHJva2U9ImJsYWNrIi8+CjxwYXRoIGQ9Ik02MC40NDM0IDU5LjUzNzFINzQuNzcxNVY0NS4yMDkiIHN0cm9rZT0iYmxhY2siLz4KPHBhdGggZD0iTTEyLjUxMDEgNjYuNjI2NUwyMi4wNTQ3IDUyLjAzMDgiIHN0cm9rZT0iYmxhY2siLz4KPHBhdGggZD0iTTI0LjgwMjcgNDkuNTA5MkwzOC44MzAxIDM5LjE0NzMiIHN0cm9rZT0iYmxhY2siLz4KPHBhdGggZD0iTTQzLjY4NTMgMzUuMjEwN0w1My40Mzg0IDIwLjc1MzQiIHN0cm9rZT0iYmxhY2siLz4KPHBhdGggZD0iTTU1LjY2MTUgMTYuODUxNkw2OS4zMjkxIDYuMDE5NjEiIHN0cm9rZT0iYmxhY2siLz4KPGNpcmNsZSBjeD0iNDEuMjYyIiBjeT0iMzcuMTczOSIgcj0iMi42MzQyOSIgdHJhbnNmb3JtPSJyb3RhdGUoLTE0Ljk0MDIgNDEuMjYyIDM3LjE3MzkpIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSJibGFjayIvPgo8Y2lyY2xlIGN4PSIyMi44MDUxIiBjeT0iNTEuMzY3MyIgcj0iMi42MzQyOSIgdHJhbnNmb3JtPSJyb3RhdGUoLTE0Ljk0MDIgMjIuODA1MSA1MS4zNjczKSIgZmlsbD0id2hpdGUiIHN0cm9rZT0iYmxhY2siLz4KPGNpcmNsZSBjeD0iNTUuMDY5IiBjeT0iMTguMDgwNiIgcj0iMi42MzQyOSIgdHJhbnNmb3JtPSJyb3RhdGUoLTM0LjQ4MjggNTUuMDY5IDE4LjA4MDYpIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSJibGFjayIvPgo8Y2lyY2xlIGN4PSI3MS42OTE1IiBjeT0iMy45NjQ1NCIgcj0iMi42MzQyOSIgdHJhbnNmb3JtPSJyb3RhdGUoLTE2Ljg4NSA3MS42OTE1IDMuOTY0NTQpIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSJibGFjayIvPgo8L3N2Zz4K";